// -------------- CA EVENT Logic -------------- //
// import { isDateInRange } from '../utils/isDateInRange';
// import {
//   eventStartDate as startDate,
//   eventEndDate as endDate,
// } from './eventDates';
// const isInRange = isDateInRange(startDate, endDate);
// ------------------------------------------------//

export const DISCOUNTS = {
  '20%': 0.2,
  '30%': 0.3,
  '40%': 0.4,
  '45%': 0.45,
  '50%': 0.5,
  '60%': 0.6,
  BNDLE: 0.6,
  CSS: 0.6,
  // Founders: 0.6,
  Military: 0.6, //60% off any body area or full body
  'Prev Tx': 0.7,
};

// -------- Military & BNDLE Discount Logic -------- //
// 60% off any body area or full body
// An additional 10% off of the bundle discount
// ------------------------------------------------//

export default DISCOUNTS;

export const BundleExcludedDiscounts = ['CSS', 'Prev Tx', '60%', '65%'];
export const PrivateSaleExcludedDiscounts = [
  ...BundleExcludedDiscounts,
  'Founders',
];
export const FullBodyExcludedDiscounts = [...BundleExcludedDiscounts, 'Event'];

// --- NEW - 2025 Bundles Discount Logic --- //
export const DISCOUNTED_RATIO = {
  vip_bundle: 0.62592,
  premier_bundle: 0.62663,
  essentials_bundle: 0.63748,
  glow_bundle: 0.60815,
  glam_bundle: 0.62872,
  glam_plus_bundle: 0.6279,
  bare_down_there_bundle: 0.62133,
  time_saver_bundle: 0.6063,
  mog_bundle: 0.62294,
  elite_bundle: 0.59992,
  exec_bundle: 0.61261,
  full_body: 0.5,
};

// --- DISCOUNT RATIO of BUNDLES when FOUNDERS DISCOUNT is applied --- //
export const FOUNDERS_DISCOUNT = {
  vip_bundle: 0.70075,
  premier_bundle: 0.70133,
  essentials_bundle: 0.70996,
  glow_bundle: 0.6865,
  glam_bundle: 0.703,
  glam_plus_bundle: 0.7023,
  bare_down_there_bundle: 0.69708,
  time_saver_bundle: 0.685,
  mog_bundle: 0.69834,
  elite_bundle: 0.67995,
  exec_bundle: 0.6901,
  full_body: 0.6,
};
